export const getFrequencyLabel = (frequency) => {
  if (!frequency) return 'N/A';
  const freq = frequency.toLowerCase();
  switch (freq) {
    case 'daily':
      return 'Daily';
    case 'weekly':
      return 'Weekly';
    case 'monthly':
      return 'Monthly';
    case 'quarterly':
      return 'Quarterly';
    case 'half_yearly':
      return 'Half Yearly';
    case 'yearly':
      return 'Yearly';
    case 'one_time':
      return 'One Time';
    default:
      return frequency;
  }
};
